<template>
  <div class="premission_index">
    <el-row class="elAdd">
      <!-- <el-button
        type="primary"
        icon="el-icon-circle-plus-outline"
        @click="dialogFormVisible = true"
        >新增</el-button
      > -->
      <!-- <iframe class="prism-player" :src="'../../../static/pdf/web/viewer.html?file=' + 'http://hk.changhongit.com/pub/resource/application/2021060201744_c.pdf'" width="1000px" height="1000px"></iframe> -->
      <!-- <pdf src="./path/to/static/relativity.pdf"></pdf> -->
      <div class="search_div">
        <div>
         <!-- 1111 -->
          <el-date-picker
      v-model="value1"
      type="daterange"
      range-separator="至"
      value-format="timestamp"
      start-placeholder="开始日期"
      unlink-panels='true'
      end-placeholder="结束日期">
    </el-date-picker>
        </div>
        <div>
          <button
            type="primary"
            class="search_click"
            @click="getSearchList()"
            >搜索</button
          >
        </div>
      </div>
    </el-row>
    <!-- 表格 -->
   
 <el-dialog
  title="影像上传"
  :visible.sync="dicomePop"
  width="70%"
  :before-close="handleClose">
      <el-form >
                 <el-form-item label="附件上传">
                <el-upload
                    ref="upload"
                    class="upload-files"
                    action=""
                    name="files"
                    multiple
                    :auto-upload="false"
                    :file-list="fileList"
                    :on-change="handleChangeedit"
                    style="display: inline;float:left;"
                >
                    <el-button slot="trigger" size="mini" type="primary">选取文件</el-button>
                </el-upload>
            </el-form-item>
    </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dicomePop = false">取 消</el-button>
    <el-button type="primary" @click="dicomePop = false">确 定</el-button>
  </span>
</el-dialog>
    <el-table
      class="premission_table"
      :data="tableDatas"
      style="width: 100%"
      :header-cell-style="{background: '#F9F9F9',color:'#999999'}"
    >
      <el-table-column type="index" label="序号" width="50" />
      <el-table-column prop="hospitalName" label="医疗机构名称" />
      <el-table-column prop="studyCount" label="检查数量"  />
      <!-- <el-tab{
						label: '二维码',
						editLabel: '',
						model: 'qrcode',
						focus: false,
						style: {
							display: 'inline-block',
							border: 0,
							width: '100px',
							height: '100px',
							background: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsAQMAAABDsxw2AAAABlBMVEX///8AAABVwtN+AAABDElEQVRo3u3ZQQ7DIAwEwOTkZ+X/v8gzuLUIb+wYpNwqNfbuARGY3lY0tBvzFzk+nvGog9yWT7L8TGxYmXdlk77kg0bI8rLRhnZ1yDb3UQ+yGkyw/sh0iSwd081n1kNWiWnWSo2QJWaWyCyBWX3IErKema0BCyFLya6GtGuma/4i0ciSM0+LDIfDmOiTrod7CNmrmccLcxpDVQSbXh8IIUvKUBpd8k/hINGQJWf2qoiDxGYxR2TbTpaITTknOJhbfJQsKZtvlLeuYJesBtPBH53FL5LIuhCyF7LlryXE7wuReZHwqoGBrALD7H6QkJVhy69PK8OhsZPVYBpj8eJJlphZQkO8OmS1GfPDfAHsX5S+uaOtDgAAAABJRU5ErkJggg==) no-repeat',
							backgroundSize:'cover',
						},
					}le-column prop="gender" label="性别" /> -->
      <!-- <el-table-column prop="sex" label="性别" width="60">
        <template slot-scope="scope">
          {{ scope.row.gender == 0 ? "男" : "女" }}
        </template>
      </el-table-column> -->
      <el-table-column prop="reportCount" label="报告数量" />
      <!-- <el-table-column prop="studyModality" label="检查类型" width="90" /> -->
      <!-- <el-table-column prop="partExamined" label="检查部位" width="180"/> -->
       
      <!-- <el-table-column
        prop="status"
        v-if="regis_id == 1"
        label="检查状态"
        width="100"
      >
        <template slot-scope="scope">
          <span :class="scope.row.status == 0 ? 'statusone' : 'statustwo'">{{
            scope.row.status == 0 ? "未阅片" : "已阅片"
          }}</span>
        </template>
      </el-table-column> -->
       <!-- <el-table-column prop="hospitalName" label="检查医院" width='100' /> -->
      <!-- <el-table-column prop="times" label="检查时间" width='170' /> -->
      <!-- <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-if='regis_id == 1 && scope.row.status == 0'
            type="text"
            @click.stop="() => edit(scope.row)"
            >查看</el-button
          >
          <p class="ningcolor" v-if='regis_id == 1 && scope.row.status == 1' @click.stop="() => warningclick(scope.row)">报告</p>
         
          <p class='ningcolor' v-if='regis_id == 0' @click.stop="() => edit(scope.row)">登记</p>
       
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 展示列表 -->
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        background=""
        layout="prev, pager, next"
        :total="totalPage"
        :current-page.sync="currentPage"
        @current-change="getMenuLinkageList(currentPage)"
      />
    </div>
    <!-- 添加弹框 -->

    <!-- 编辑弹框 -->
    <el-dialog
      top="15vh"
      title=""
      :visible.sync="dialogFormVisibleEdit"
      width="60%"
      :close-on-click-modal="false"
    >
      <div><h2 class="tan_header">基本资料</h2></div>
      <el-form :model="formEdit" :rules="rules" :inline="true" ref="formEdit">
        <!-- <el-form-item prop="content" label="公告内容:" :label-width="formLabelWidth">
          <el-input type="textarea" :row="3" placeholder="请输入公告内容" v-model="formEdit.content" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item
          prop="username"
          label="患者姓名:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入节点名称"
            v-model="formEdit.username"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="gender" label="性别:" :label-width="formLabelWidth">
          <el-select v-model="formEdit.gender" placeholder="请选择菜单类型">
            <el-option label="男" value="0" />
            <el-option label="女" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item
          prop="birthday"
          label="出生年月:"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            v-model="formEdit.birthday"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item
          prop="studyAge"
          label="年龄:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入年龄"
            v-model="formEdit.studyAge"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="idcard"
          label="身份证号:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入身份证号"
            v-model="formEdit.idcard"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="phone"
          label="联系电话:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入联系电话"
            v-model="formEdit.phone"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <div v-text="formEdit.selected2"></div>
        <el-form-item
          prop="area_code"
          label="地区:"
          class="area_box"
          :label-width="formLabelWidth"
        >
          <area-cascader type='text' v-model="formEdit.selected2" :data="pca"></area-cascader>
        </el-form-item>
        <el-form-item
          prop="street"
          label="详细地址:"
          :label-width="formLabelWidth"
        >
          <el-input
            width='200'
            placeholder="请输入详细地址"
            v-model="formEdit.street"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleEdit = false">取 消</el-button>
        <el-button type="primary" @click="postFormEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pca, pcaa } from "area-data";
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
import "vue-pdf-app/dist/icons/main.css";
// import { addAnnounce, deleteAnnounce, editAnnounce, announceList } from '@/api/shop.js'

export default {
  components: {
    VuePdfApp
  },
  name: "Premission",
  data() {
    return {
      fileList:[],
      dialogVisible:false,
      dicomePop:false,
      value1:[],
      checkUrl:'',
      pdfUrl:'',
      selected2: "",
      selected: [], //数组对应的就是选中的那个省市区。根据type来确定是省市区汉字的数组还是编码组成的数组。           //selected[0]省。selected[1]市。selected[2]区。
      pca: pca,
      pcaa: pcaa,
      area_code_array: "",
      times: "",
      regisactive: "未登记",
      regis_id: "0",
      register: [
        {
          name: "未登记",
          id: 0,
        },
        {
          name: "已登记",
          id: 1,
        },
      ],
      day: "3",
      active: "一周内",
      cycle: [
        {
          name: "今天",
          id: 1,
        },
        {
          name: "三天内",
          id: 2,
        },
        {
          name: "一周内",
          id: 3,
        },
      ],
      hospitallist: "",
      partExamined: "",
      hospitalId: "",
      modality: "",
      departmentOption: [
        {
          name: "CT",
          id: 1,
        },
        {
          name: "MR",
          id: 2,
        },
        {
          name: "MG",
          id: 3,
        },
        {
          name: "DX",
          id: 4,
        },
        {
          name: "OT",
          id: 5,
        },
      ],
      examinationSite: [
        {
          name: "头部",
          id: 1,
          value:'HEAD'
        },
        {
          name: "颈部",
          id: 2,
          value:'NECK'
        },
        {
          name: "胸部",
          id: 3,
          value:'CHEST'
        },
        {
          name: "腹部",
          id: 4,
          value:'ABDOMEN'
        },
        {
          name: "乳腺",
          id: 5,
          value:'BREAST'
        },
        {
          name: "上肢",
          id: 6,
          value:'UPPER EXTREMITIES'
        },
        {
          name: "下肢",
          id: 7,
          value:'LOWER EXTREMITIES'
        },
      ],
      listlist: "",
      keysEdit: [],
      tableDatas: [],
      studyNo: "",
      menuList: "",
      propd: {
        multiple: true,
        label: "name",
        value: "id",
      },
      optionss: [
        {
          value: 1,
          label: "东南",
          children: [
            {
              value: 2,
              label: "上海",
              children: [
                { value: 3, label: "普陀" },
                { value: 4, label: "黄埔" },
                { value: 5, label: "徐汇" },
              ],
            },
            {
              value: 7,
              label: "江苏",
              children: [
                { value: 8, label: "南京" },
                { value: 9, label: "苏州" },
                { value: 10, label: "无锡" },
              ],
            },
            {
              value: 12,
              label: "浙江",
              children: [
                { value: 13, label: "杭州" },
                { value: 14, label: "宁波" },
                { value: 15, label: "嘉兴" },
              ],
            },
          ],
        },
        {
          value: 17,
          label: "西北",
          children: [
            {
              value: 18,
              label: "陕西",
              children: [
                { value: 19, label: "西安" },
                { value: 20, label: "延安" },
              ],
            },
            {
              value: 21,
              label: "新疆维吾尔族自治区",
              children: [
                { value: 22, label: "乌鲁木齐" },
                { value: 23, label: "克拉玛依" },
              ],
            },
          ],
        },
      ],
      propss: {
        multiple: true,
        children: "children",
        checkStrictly: true,
        label: "name",
        value: "name",
      },
      isAllSelect: false,
      keys: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      pstlist: "",
      permissionOptions: [],
      checkList: "",
      options: "",
      username: "",
      totalPage: 0,
      currentPage: 1,
      tableData: [],
      dialogFormVisible: false,
      dialogFormVisibleEdit: false,
      formLabelWidth: "120px",
      list: "",
      formEditlist: [],
      formEdit: {
        id: "",
        // content:"",
        // visible: "",
        // index: "",
        hospitalIds: "",
        // url: "",
        // icon: "",
        username: "",
        idcard: "",
        phone: "",
        street: "",
        selected2: "",
        studyAge: "",
        grade: "",
        gender: "",
        birthday: "",
        pid: "",
        remark: "",
        pstlist: "",
        permissions: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入患者姓名", trigger: "blur" },
        ],
        idcard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        street: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        // studyAge: [{ required: true, message: "请输入患者年龄", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getCdlist();
    // this.getMenuLinkageList();
    this.getMenuLinkageList();
    this.getPermissionList();
    // 获取医院权限列表 搜索用
    this.getListMyHospital();
  },
  watch: {
    formEditlist(newVal) {
      this.formEdit.hospitalIds = newVal.join();
      console.log(this.formEdit.hospitalIds);
    },
    list(newVal) {
      this.form.hospitalIds = newVal.join();
      console.log(this.form.hospitalIds);
    },
  },
  methods: {
    handleChangeedit(item, fileList) {
            console.log(item, fileList)
            // this.fileList = fileList
        let formData = new FormData()
        let file = item.raw
        formData.append('file', file)
        formData.append('token', sessionStorage.getItem("token"))
        console.log('formData',formData)
          this.http.post(this.GLOBAL.BASE_URL + 'v1/study/uploadDcm', formData)
					.then(response => {
						console.log(response)
            if(response.data.code == 200){
              // this.formEdit.fileId = response.data.data.id
              // this.filesId.push(response.data.data.id)
              // console.log('response',this.filesId)
               this.$message({
          message: '上传成功',
          type: "success",
        });
              return
            }
             this.$message({
          message: response.data.msg,
          type: "error",
        });
        // this.$refs["upload"].$refs["upload-inner"].handleChangeedit()
					})
					.catch(err => {
						console.error(err);
					});
        },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    warningclick(row){
      console.log(row);
        let {href}= this.$router.resolve({
    path: "/historyRecord",
           query: {
              id: row.studyId,
            }  
  });
  window.open(href, '_blank');
    },
    registerclick(name, id, page = 1, page_num = 10) {
      this.regisactive = name;
      this.regis_id = id;
      depot
        .get({
          url: "/v1/analysis/hospitals",
          params: {
            page: page,
            pageSize: page_num,
            token: sessionStorage.getItem("token"),
            // username:this.username,
            // studyNo:this.studyNo,
            // modality:this.modality,
            // partExamined:this.partExamined,
            // hospitalId:this.hospitalId,
            day: this.day,
            status: this.regis_id,
            startTime:this.value1[0],
            endTime:this.value1[1],
          },
        })
        .then((res) => {
          console.log(res);
          this.totalPage = (res.data.count / page_num) * 10;
          this.tableDatas = res.data.list;
          console.log(this.tableDatas);
          this.tableDatas.forEach((element) => {
            console.log(this.time(element.studyDatetime));
            element.times = this.time(element.studyDatetime);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cycleChoice(name, id) {
      this.active = name;
      console.log(id);
      this.day = id;
    },
    getListMyHospital() {
      depot
        .get({
          url: "/v1/hospital/listMyHospital",
          params: {
            token: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.hospitallist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMenuIdsEdit() {
      // let menuIds = this.$refs.menusTree.getCheckedKeys()
      // this.roleForm.menu_ids = menuIds
      if (Array.isArray(this.$refs.menusTreeEdit.getCheckedKeys())) {
        this.formEdit.permissions = this.$refs.menusTreeEdit
          .getCheckedKeys()
          .join();
      }
      console.log(this.formEdit.permissions);
    },
    getCdlist() {
      depot
        .post({
          url: "/backend/menu/getMenus",
          data: {},
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.data;
          console.log(this.tableData);
          this.menuList = JSON.parse(JSON.stringify(res.data));
          // this.options.forEach((val, index) => {
          //   val.children.forEach((valus, index) => {
          //     delete valus.children;
          //   });
          //   // delete val.children
          // });
          console.log(this.menuList);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    edit(data) {
      // let { type, id, parent_id, title, icon, path, vue_route, permissions } = data
      console.log(data);
      this.$router.push({
              path:'/study/record/add',
              query:{
              userId:data.studyId
        }
            })
      // this.dialogFormVisibleEdit = true;
      // this.formEdit = data;
      // this.formEditlist = data.hospitalIds.split(",");
      // var str = "";
      // var arrays = "";
      // data.permissions.map((item) => {
      //   str = str + item.menuId + ",";
      // });
      // str =
      //   str.substring(str.length - 1) == ","
      //     ? str.substring(0, str.length - 1)
      //     : str;
      // console.log(str);
      // this.keysEdit = str.split(",").map(Number);
      // this.formEdit.permissions = str.split(",").map(Number).join();
      // console.log(this.keysEdit);
      // console.error(this.formEdit.permissions);
      // console.log(data.permissions);
      // this.formEditlist = arr.map(item => item.split(':'))
      // this.formEdit.pstlist = data.permissions;
      // console.log(this.formEdit);
      // depot
      //   .get({
      //     url: "/v1/study/getStudy",
      //     params: {
      //       token: sessionStorage.getItem("token"),
      //       id: data.studyId,
      //     },
      //     config: {},
      //   })
      //   .then((res) => {
      //     console.log(res);
      //     this.formEdit = res.data;
      //   });
      // menuDetail({
      //   sign: '111',
      //   token: sessionStorage.getItem('token'),
      //   id: data.id
      // })
      //   .then(res => {
      //     this.editForm = res.data
      //     this.editForm.sign = '111'
      //     this.editForm.token = sessionStorage.getItem('token')
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
      // this.getMenuLinkageList(data.type)
    },
    getMenuIds() {
      // let menuIds = this.$refs.menusTree.getCheckedKeys()
      // this.roleForm.permissions = menuIds
      if (Array.isArray(this.$refs.menusTree.getCheckedKeys())) {
        console.log(this.$refs.menusTree.getCheckedKeys());
        this.form.permissions = this.$refs.menusTree.getCheckedKeys().join();
      }
      console.log(this.form.permissions);
    },
    deleteClick(val) {
      console.log(val);
      depot
        .post({
          url: "/backend/role/delete",
          data: {
            id: val.id,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.success == true) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getMenuLinkageList();
            return;
          }
          this.$message({
            message: res.msg,
            type: "error",
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    time(time = +new Date()) {
      var date = new Date(time + 8 * 3600 * 1000);
      return date.toJSON().substr(0, 19).replace("T", " ").replace(/-/g, "-");
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    handleChange() {
      console.log(this.value);
    },
    getMenuLinkageList(page = 1, page_num = 10) {
      // console.log(value);
      depot
        .get({
          url: "/v1/analysis/hospitals",
          params: {
            page: page,
            pageSize: page_num,
            token: sessionStorage.getItem("token"),
            startTime:this.value1[0],
            endTime:this.value1[1],
          },
        })
        .then((res) => {
          console.log(res);
          this.totalPage = (res.data.count / page_num) * 10;
          console.error(this.totalPage);
          this.tableDatas = res.data.list;
          console.log(this.tableDatas);
          this.tableDatas.forEach((element) => {
            console.log(this.time(element.studyDatetime));
            element.times = this.time(element.studyDatetime);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPermissionList(value) {
      // console.log(value);
      depot
        .get({
          url: "/v1/hospital/listHospital",
          params: {
            token: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log(res.data);
          this.permissionOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSearchList(page = 1, page_num = 10) {
      depot
        .get({
          url: "/v1/analysis/hospitals",
          params: {
            page: page,
            pageSize: page_num,
            token: sessionStorage.getItem("token"),
            startTime:this.value1[0],
            endTime:this.value1[1],
          },
        })
        .then((res) => {
          console.log(res);
          this.totalPage = (res.data.count / page_num) * 10;
          this.tableDatas = res.data.list;
          console.log(this.tableDatas);
          this.tableDatas.forEach((element) => {
            console.log(this.time(element.studyDatetime));
            element.times = this.time(element.studyDatetime);
          });
          this.currentPage = 1
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postForm() {
      console.log(this.list);
      //  this.form.permissions.forEach((val, index) => {
      //       console.log(val);
      //       // delete val.children
      // });
      // let str = "";
      // for (var i = 0; i < this.permissions.length; i++) {
      //   str += this.permissions[i] + "|";
      //   var newlist = str.replace(/\,/g, ":");
      //   this.form.permissions = newlist.replace(/\|/g, ",");
      //   // this.form.permissions = this.form.permissions.substr(0,this.form.permissions.length-1);
      //   console.log(this.form.permissions);
      // }
      // this.form.hospitalIds = this.list.map(item => item.join(':')).join(',');
      // console.log(this.list.map(item => item.join(':')).join(','));
      // console.log(this.form.hospitalIds);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          depot
            .post({
              url: "/backend/role/save",
              data: this.form,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.dialogFormVisible = false;
                this.getMenuLinkageList();
                return;
              }
              this.$message({
                message: "新增失败",
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
          // addAnnounce(this.form).then(res => {
          //   this.$message({
          //     message:res.message,
          //     type:"success",
          //     duration:2000
          //   })
          //   this.dialogFormVisible = false;
          //   this.getMenuLinkageList(this.currentPage);
          //   this.$refs["form"].resetFields();
          // }).catch(err => {
          //   console.log(err)
          // })
        }
      });
    },
    handleDelete(row) {
      this.$confirm("是否确认删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAnnounce({
            id: row.id,
          })
            .then((res) => {
              this.getMenuLinkageList(this.currentPage);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    handleEdit(row) {
      let {
        id,
        username,
        idcard,
        selected2,
        phone,
        street,
        studyAge,
        grade,
        pid,
        remark,
        gender,
        birthday,
      } = row;
      this.formEdit.id = id;
      // this.formEdit.content = content
      this.formEdit.username = username;
      this.formEdit.idcard = idcard;
      this.formEdit.phone = phone;
      this.formEdit.street = street;
      this.formEdit.selected2 = selected2;
      this.formEdit.studyAge = studyAge;
      this.formEdit.pid = pid;
      this.formEdit.remark = remark;
      // this.formEdit.pstlist = pstlist;
      // this.formEdit.pstlist = permissions;
      // this.formEdit.visible = visible;
      // this.formEdit.index = index;
      // this.formEdit.url = url;
      this.formEdit.grade = grade;
      this.formEdit.gender = gender;
      this.formEdit.birthday = birthday;
      this.dialogFormVisibleEdit = true;
    },
    postFormEdit() {
      console.error(this.formEdit.permissions);
      // this.formEdit.hospitalIds = this.formEditlist.map(item => item.join(':')).join(',');
      // console.log(this.formEditlist.map(item => item.join(':')).join(','));
      // console.log(this.formEdit.hos pitalIds);
      this.$refs["formEdit"].validate((valid) => {
        if (valid) {
          depot
            .post({
              url: "/backend/role/update",
              data: this.formEdit,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: res.data,
                  type: "success",
                });
                this.dialogFormVisibleEdit = false;
                this.getMenuLinkageList();
                return;
              }
              this.$message({
                message: "修改失败",
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
          // editAnnounce(this.formEdit)
          //   .then((res) => {
          //     this.$message({
          //       message: res.message,
          //       type: "success",
          //       duration: 2000,
          //     });
          //     this.dialogFormVisibleEdit = false;
          //     this.getMenuLinkageList(this.currentPage);
          //     this.$refs["formEdit"].resetFields();
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
        }
      });
    },
  },
};
</script>

<style scoped>
.ningcolor {
  color: #E6A23C;
  cursor:pointer;
  font-weight: 500;
}
.tan_header {
  margin-left: 40px;
  margin-bottom: 15px;
}
/deep/.area_box .area-select .area-selected-trigger {
  padding: 0px 10px !important;
}
.search_click {
  color:#fff;
  width: 100px;
  height: 40px;
  background: #009b43;
  border: none;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
    border-radius: 3px;
}
.search_click:hover {
  border-radius: 3px;
  background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);
  box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
   background-position: 100% 0;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.box_cycle {
  display: inline-flex;
  align-items: center;
}
.box_regis {
  display: inline-flex;
  margin-bottom: 28px;
}
.box_cycle span:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: 1px solid #fff;
}
.box_cycle span:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: 1px solid #fff;
}
.premission_index {
  padding: 20px;
  background: #fff;
  margin-top: 10px;
  box-sizing: border-box;
}
.search_div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search_input {
  width: 120px;
}
.premission_table {
  margin-top: 10px;
}
.pagination_box {
}
.pagination {
  padding: 0 20px;
  margin-top: 20px;
  text-align: right;
}
.elAdd {
  margin-bottom: 10px;
}
.cyclestyle {
  cursor: pointer;
  width: 62px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  background: #c4c4c4;
  font-size: 14px;
  opacity: 0.8;
}
.active {
  background: #009b43;
  cursor: pointer;
  color: #fff;
}
.register {
  cursor: pointer;
  width: 139px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  background: #c4c4c4;
  font-size: 14px;
  opacity: 0.8;
}


.registeractive {
  cursor: pointer;
  color: #fff;
  background: #009b43;
}
.statusone {
  color: #ed6f00 !important;
}
/deep/.pagination .btn-prev {
  display: none !important;
}
/deep/.pagination .btn-next {
  display: none !important;
}

/deep/.pagination .el-pager li:hover {
  color: #000 !important;
}
/deep/.pagination .el-pager .active {
  background: #009b43 !important;
  color: #fff !important;
}
</style>




// WEBPACK FOOTER //
// src/views/analysishospital/index.vue